const translation = {
  // Form titles and buttons
  "orderForm": "טופס הזמנה",
  "duplicateOrderForm": "שכפול הזמנה",
  "selectRole": "בחר תפקיד",
  "cancel": "ביטול",
  "sendOrder": "שליחת הזמנה",
  "editOrderProducts": "ערוך מוצרים להזמנה",
  "uploadFiles": "העלאת קבצים",
  "filesSelected": "קבצים נבחרו",
  "approve": "אישור",
 
  // Customer fields
  "selectOrderingCustomer": "בחירת לקוח מזמין",
  "selectReceivingCustomer": "בחירת לקוח מקבל",
  "enterCustomerName": "הקלד שם לקוח",
  "enterCustomerPhone": "הקלד טלפון לקוח",
  "requiredCustDes": "שדה שם לקוח חובה בלקוח מזדמן  ",
  "requiredPhone": "שדה טלפון חובה בלקוח מזדמן  ",
  "noOptions": "אין אפשרויות לבחירה",
  "cancelSelection": "בטל בחירה",
  "external": "חיצוני",
  "internal": "פנימי",
  "customerName": "שם לקוח",
  "orderNumber": "מספר הזמנה",
  "status": "סטטוס",
 
  // Address fields
  "street": "רחוב",
  "floor": "קומה",
  "apartment": "דירה",
  "house": "בית",
  "city": "עיר",
  "country": "מדינה",
 
  // Site selection
  "selectSites": "בחירת אתרים",
  "noSitesAvailable": "אין אתרים זמינים",
 
  // Products
  "selectedProductsCount": "מספר מוצרים שנבחרו",
  "productRequiresApproval": "מוצר זה דורש אישור",
  "quantityOverLimit": "כמות המוצר שהוזמנה חורגת מהמלאי הזמין",
 
  // Contract and delivery
  "selectContractCode": "בחירת קוד התקשרות",
  "deliveryDate": "תאריך אספקה",
  "orderDate": "תאריך הזמנה",
  "deliveryDateLabel": "תאריך אספקה",
 
  // Notes fields
  "driverNotes": "הערות לנהג",
  "customerOrderText": "הזמנת לקוח טקסט",
  "internalDialog": "דו שיח פנימי",
 
  // Validation messages
  "selectOrderingCustomerRequired": "יש לבחור לקוח מזמין",
  "selectProductsRequired": "יש לבחור לפחות מוצר אחד",
  "deliveryDateRequired": "יש להזין תאריך אספקה",
  "contractCodeRequired": "יש לבחור קוד התקשרות",
  "deliveryDateInvalid": "התאריך שבחרת אינו זמין לאספקה",
  "selectCustomerPhoneRequired": "יש לבחור טלפון ללקוח מזדמן ",
  "selectCustomerNameRequired": "יש לבחור שם ללקוח מזדמן ",
  "fillRequiredFields": "נא למלא את כל השדות הנדרשים",
  "citySearchMinChars": "הקלד לפחות 2 תווים לחיפוש",
  "noResults": "לא נמצאו תוצאות",
 
  // Success/Error messages
  "orderCreatedSuccess": "הזמנה נוצרה בהצלחה",
  "orderNeedsApproval": "חלק מהמוצרים שהזמנת צריכים לקבל אישור, ההזמנה תשמר לאחר האישור",
  "errorLoadingSites": "שגיאה בטעינת האתרים",
  "errorLoadingProducts": "שגיאה בטעינת המוצרים",
  "errorCreatingOrder": "שגיאה ביצירת ההזמנה. בדוק תקינות נתונים או פנה למנהל המערכת",
  "selectCustomerFirst": "יש לבחור לקוח מקבל או מזמין תחילה",
  "warning": "שים לב: כמות אחד או יותר מהפריטים בהזמנתך גדולה מהכמות במלאי. להמשיך?",
  "loading": "טוען...",
  "dataError": "שגיאה בקבלת נתונים."
};

export default translation;